import type { ReactNode } from 'react';
import { IconButton, Stack, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

export interface RowActionsProps {
  onEdit?: () => void;
  onDelete?: () => void;
  /** Düzenle'den önce ek IconButton'lar (ör. "Taşı"). */
  leading?: ReactNode;
  editAriaLabel?: string;
  deleteAriaLabel?: string;
  editTooltip?: string;
  deleteTooltip?: string;
}

/** Liste satırlarının sağ ucundaki Düzenle/Sil ikon aksiyonları — aria-label'lar
 *  ('Düzenle' / 'Sil') mevcut testlerle uyumlu kalır. */
export function RowActions({
  onEdit,
  onDelete,
  leading,
  editAriaLabel = 'Düzenle',
  deleteAriaLabel = 'Sil',
  editTooltip,
  deleteTooltip,
}: RowActionsProps) {
  const editBtn = onEdit && (
    <IconButton size="small" onClick={onEdit} aria-label={editAriaLabel}>
      <EditIcon fontSize="small" />
    </IconButton>
  );
  const deleteBtn = onDelete && (
    <IconButton size="small" onClick={onDelete} aria-label={deleteAriaLabel}>
      <DeleteIcon fontSize="small" />
    </IconButton>
  );
  return (
    <Stack direction="row" spacing={0.25} sx={{ justifyContent: 'flex-end' }}>
      {leading}
      {editTooltip && editBtn ? <Tooltip title={editTooltip}>{editBtn}</Tooltip> : editBtn}
      {deleteTooltip && deleteBtn ? <Tooltip title={deleteTooltip}>{deleteBtn}</Tooltip> : deleteBtn}
    </Stack>
  );
}
